import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import _ from 'lodash';
import config from '@/config';
import ListLayout from '@/layouts/ListLayout';
import { PageSeo } from '@/components';
import { API } from '@/core/api';

export default function Blog({ posts }) {
	return (
		<>
			<PageSeo
				title={`Blog - ${config.author}`}
				description={config.description}
				url={`${config.siteUrl}/blog`}
			/>
			<ListLayout posts={posts} title='All Posts' />
		</>
	);
}

export const getStaticProps = async ({ locale }) => {
	const apiRef = new API();
	const posts = await apiRef.getPosts();
	return {
		props: {
			posts,
			...(await serverSideTranslations(locale, ['common'])),
		},
		revalidate: 1,
	};
};
